import React, { memo } from 'react';
import { DEMO_USER_PICTURE } from '../../../common/common';
import useRedirect from '../../customHooks/useRedirect';
import LazyImage from '../../CustomLibraries/LazyImage';
import { AiOutlineUserAdd, FiShare2 } from '../../icons';
import './css/_doctorCardV2.scss';

function DoctorCardV2({
  profile_image,
  doctor_name,
  doctor_id,
  subtitle,
  profile,
  gtmTagVariable = ''
}) {
  const { redirectTo } = useRedirect();
  const click = () => redirectTo('SpeakerProfile', doctor_id, doctor_name);
  return (
    <div
      className={`w-100 doctorCardV2Box bg-white shadow cursorPointer rounded-3 d-flex position-relative overflow-hidden p-3 p-md-4 pe-50 pe-md-50 ${gtmTagVariable}_doctorCardV2`}
      onClick={click}
    >
      <div
        className={`bg-primary rounded-pill position-absolute connectIcon z-1 ${gtmTagVariable}_doctorCardV2`}
      >
        <AiOutlineUserAdd
          customClass={`fs-1 text-white position-absolute ${gtmTagVariable}_doctorCardV2_icon`}
          gtmTagVariable={`${gtmTagVariable}_doctorCardV2_icon`}
        />
      </div>

      <div className="d-flex z-1">
        {profile_image && (
          <div className="doctorPic rounded-circle border border-2 border-primary p-1 me-3">
            <LazyImage
              src={profile_image}
              alt="doctor image"
              className={`object-fit-cover w-100 h-100 float-start ${gtmTagVariable}_doctorCardV2`}
              extraClass={
                'w-100 h-100 position-relative rounded-circle overflow-hidden d-flex align-items-center justify-content-center bg-light'
              }
              fallback_image={DEMO_USER_PICTURE}
            />
          </div>
        )}

        <div className="d-flex flex-column text-start justify-content-center flex-1">
          {doctor_name && (
            <h2
              className={`fs-16 text-black fw-medium cursorPointer mb-1 ${gtmTagVariable}_doctorCardV2`}
            >
              {doctor_name}
            </h2>
          )}
          {!!subtitle && subtitle != 0 ? (
            <span className={`fs-4 text-black line-clamp-2 ${gtmTagVariable}_doctorCardV2`}>
              {subtitle}
            </span>
          ) : null}
          {!!profile && profile != 0 ? (
            <h4 className={`fs-4 text-dark my-1 line-clamp-2 ${gtmTagVariable}_doctorCardV2`}>
              {profile}
            </h4>
          ) : null}
          <span className={`text-primary fw-medium ${gtmTagVariable}_doctorCardV2`}>
            View profile{' '}
          </span>
        </div>
      </div>
    </div>
  );
}
export default memo(DoctorCardV2);
